<script>
  import { afterUpdate } from 'svelte'
  import InlineInput from 'svelte-inline-input'

  let newTodo = ''
  let todos = JSON.parse(localStorage.getItem('todos')) || []

  function addTodo() {
    newTodo = newTodo.trim()
    // exit if empty string
    if (!newTodo) return

    todos = [...todos, {
      done: false,
      text: newTodo
    }]

    // clean variable and input
    newTodo = ''
  }

  function removeDone() {
    todos = todos.filter(el => !el.done)
  }

  afterUpdate(() => {
    //document.querySelector('li input.todo').focus()
    // store data also in the browser
    localStorage.setItem('todos', JSON.stringify(todos))
  })
</script>

<main>
	<h1>TODO</h1>

  <div class="list">
    <ul>
      {#each todos as todo}
      <li class="{todo.done ? 'done' : ''}"><input type="checkbox" bind:checked={todo.done}> <InlineInput bind:value={todo.text}/></li>
      {/each}
      <li>
        <form on:submit|preventDefault={addTodo}>
          <input type="text" class="todo" bind:value={newTodo}/>
        </form>
      </li>
    </ul>
  </div>

  <button on:click={addTodo}>Add</button>
  <button on:click={removeDone}>Clean</button>
</main>
